<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-flex xs12 md44 class="my-3">

    <div class="text-xs-center">
      <h2 class="headline">チームへの招待状</h2>
      <p>チームに加わって、一緒にバスケットボールをしましょう。</p>
    </div>
  </v-flex>


<v-btn block  @click='create'>チームに入る</v-btn>

<div id="fb-root"></div>
  <!-- Your send button code -->
  <div class="fb-send" 
    data-href="https://www.your-domain.com/your-page.html" 
    data-layout="button_count">
  </div>

    </v-flex>
  </v-layout>
</template>


<script>

import firebase from 'firebase'

export default {
  components: {
    firebase
  },
  data () {
    return {
      customurl: ''
    }
  },
  mounted () {
  },
  created () {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        // サインインしていない状態
        // サインイン画面に遷移する等
        // 例:
        location.href = '/#/auth?' + this.$route.params.id
      } else {
        // サインイン済み
      }
    })
  },
  methods: {
    create: function () {
      console.log('create')
      var db = firebase.firestore()
      let user = firebase.auth().currentUser

      let obj = {}
      obj.role = 'MEMBRE'
      obj.team = this.$route.params.id
      obj.user = user.uid
      obj.status = 'PENDING'

      console.log(obj)
      db.collection('m2m_teams_users').add(obj).then(function () {
        console.log('Document successfully written!')
      }).catch(function (error) {
        console.log('Error add document:', error)
      })
    }
  }
}
</script>

<style>
.ggmap {
position: relative;
padding-bottom: 56.25%;
padding-top: 30px;
height: 0;
overflow: hidden;
}
 
.ggmap iframe,
.ggmap object,
.ggmap embed {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/team/Join.vue